// extracted by mini-css-extract-plugin
module.exports = {"switchArrow":"_id__switchArrow__xO2cP"};